module.exports = __webpack_public_path__ + "media/images/earthmover-2c5444c9979ed6ff275794d3a33ff801.svg";